"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var payment2C2PStyles_1 = require("./payment2C2PStyles");
var Payment2C2P_1 = require("./Payment2C2P");
var DefaultButton_1 = require("../../../../../../common/components/presentation/Buttons/DefaultButton");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var usePayment2C2P_1 = require("../../../hooks/usePayment2C2P");
var TransactionErrorTypes_1 = require("../../../../../../common/enum/TransactionErrorTypes");
var ScrollInViewTypes_1 = require("../../../../../../common/enum/ScrollInViewTypes");
var usePlatformConfig_1 = require("../../../../../../common/react/usePlatformConfig");
var globalTypes_1 = require("../../../../../../__generated__/globalTypes");
var softLockModal_1 = require("../../../../../checkout4/components/softLockModal/softLockModal");
var usePriceFormatter_1 = require("../../../../../../../../common/react/usePriceFormatter");
var useWidgetContext_1 = require("../../../../../../common/react/useWidgetContext");
var Payment2C2PContainer = function (_a) {
    var goToNextStep = _a.goToNextStep, deal = _a.deal, loading = _a.loading;
    var styles = payment2C2PStyles_1.default();
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var _b = react_1.useState(false), hideIframe = _b[0], setHideIframe = _b[1];
    var _c = usePlatformConfig_1.default().platformConfig, isCheckout4Enabled = _c.platformFeatures.isCheckout4Enabled, _d = _c.priceDisplay.primary, currency = _d.currency, decimalScale = _d.decimalScale, currencyFormatConfig = _d.currencyFormatConfig, isCoeCategoryAmountEnabled = _c.payment.isCoeCategoryAmountEnabled;
    var priceFormatter = usePriceFormatter_1.default({
        currency: currency,
        dimensions: {
            country: dimensions.country,
            language: dimensions.language,
        },
        decimals: decimalScale,
        currencyFormatConfig: currencyFormatConfig,
    });
    var checkTransaction = localStorage.getItem('isTransactionComplete');
    var isAuthorized = localStorage.getItem('lastPaymentStatus') === TransactionErrorTypes_1.TransactionErrorTypes.AUTHORIZED;
    var _e = usePayment2C2P_1.usePayment2C2P(deal, loading), initData = _e.initData, initError = _e.initError, btnLoading = _e.btnLoading, handlePayment = _e.handlePayment, isPaymentFailed = _e.isPaymentFailed, isTransactionComplete = _e.isTransactionComplete, isStatusLoading = _e.isStatusLoading, softLocked = _e.softLocked, softLockedErrorMsg = _e.softLockedErrorMsg, isErrorPaymentInitSoftLock = _e.isErrorPaymentInitSoftLock, handleCloseSoftLockModal = _e.handleCloseSoftLockModal;
    var theme = core_1.useTheme();
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var handleIframeChange = function () {
        if (isTransactionComplete) {
            setHideIframe(true);
        }
    };
    react_1.useEffect(function () {
        if (!isAuthorized && checkTransaction === 'true' && hideIframe) {
            window.top.location = window.location;
        }
    }, [hideIframe]);
    react_1.useEffect(function () {
        localStorage.setItem('isTransactionComplete', 'false');
    }, []);
    react_1.useEffect(function () {
        if (isAuthorized && isTransactionComplete) {
            goToNextStep();
        }
    }, [isStatusLoading]);
    react_1.useEffect(function () {
        if (isCheckout4Enabled && !initData && isMobile) {
            var continueButton = document.querySelector('[data-test="button:checkout:2C2P"]');
            if (continueButton) {
                continueButton.scrollIntoView({
                    block: 'center',
                    inline: 'center',
                    behavior: ScrollInViewTypes_1.ScrollInViewBehaviourType.SMOOTH,
                });
            }
        }
    }, [initData, isStatusLoading, isMobile, isCheckout4Enabled]);
    var buttonText = react_1.useMemo(function () {
        var _a;
        if (isPaymentFailed) {
            return 'trans__checkout__payment_page__try_again_CTA';
        }
        if (((_a = deal) === null || _a === void 0 ? void 0 : _a.journeyType) === globalTypes_1.JourneyType.online_order) {
            return 'trans__checkout__next_step__payment_page__proceed_to_order_CTA';
        }
        return 'trans__checkout__payment_page__pay_CTA';
    }, [deal, isPaymentFailed]);
    var amount = react_1.useMemo(function () {
        var _a, _b, _c, _d;
        if (isCoeCategoryAmountEnabled && deal.journeyType === globalTypes_1.JourneyType.online_order) {
            var categoryAmount = (_d = (_c = (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.car) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.coeCategoryAmount) === null || _d === void 0 ? void 0 : _d.find(function (ceoCategoryAmount) { return ceoCategoryAmount.currency === currency; });
            if (categoryAmount) {
                return priceFormatter.format(Number(categoryAmount.amount));
            }
        }
        return '';
    }, [deal, currency, isCoeCategoryAmountEnabled]);
    if (isStatusLoading || isAuthorized)
        return null;
    return (<core_1.Box className={styles.container}>
      <Payment2C2P_1.default initError={initError} isPaymentFailed={isPaymentFailed} paymentAmount={amount}/>
      {!initData ? (<DefaultButton_1.default className={[styles.payButton]} dataTest="button:checkout:2C2P" variant="contained" disabled={btnLoading} onClick={handlePayment}>
          {amount ? <Translation_1.default id={buttonText} values={{ amount: amount }}/> : <Translation_1.default id={buttonText}/>}
        </DefaultButton_1.default>) : (<core_1.Box className={hideIframe ? styles.hiddenFrame : styles.iframeContainer}>
          <iframe data-test="payment:2C2P:iframe" src={initData.url} onLoad={handleIframeChange}/>
        </core_1.Box>)}
      <softLockModal_1.default isOpen={softLocked} isErrorPaymentInitSoftLock={isErrorPaymentInitSoftLock} softLockedErrorMsg={softLockedErrorMsg} onClose={function () { return handleCloseSoftLockModal(false); }}/>
    </core_1.Box>);
};
exports.default = Payment2C2PContainer;
